export class InvolvedPartyRelationType {
    iprtId: string = null;
    iprtName: string = null;
}
